// Images live here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview
export default {
  partnerText: {
    heading: 'our partners',
    subheading: 'We\'ve worked with over 200 partners including:'
  },
  keyPartnerList: [
    'bose',
    'campbells',
    'clorox',
    'estee-lauder',
    'general-mills',
    'gsk',
    'lego',
    'levis',
    'loreal',
    'lvmh',
    // 'pandg',
    'unilever'
  ],
  partnerList: [
    // 'banana-republic',
    // 'benefit-cosmetics',
    'bose',
    'dollar-shave-club',
    // 'dr-brandt',
    'estee-lauder',
    // 'gopro',
    'herbal-essences',
    'hp',
    'lancome',
    'levis',
    'loreal',
    'mattel',
    // 'mondelez',
    'olay',
    'old-spice',
    'oreo',
    'pampers',
    // 'pandg',
    'pepperidge-farm',
    // 'revlon',
    'timberland',
    't-mobile',
    'under-armour',
    'unilever',
    'zappos'
  ]
}



// WEBPACK FOOTER //
// ./client/store/imports/Partners.js